import React, { useState, useEffect, Fragment, useRef } from 'react';
import ReactDOM from 'react-dom';
import { component } from 'picoapp';
import { atcb_init } from 'add-to-calendar-button';
// import './atcb.min.css';

const AddToCalendar = ({ node }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    // console.log(JSON.parse(node.parentNode.querySelector('[data-event-info]').text))
    setData(JSON.parse(node.parentNode.querySelector('[data-event-info]').text));
  }, []);

  useEffect(() => atcb_init, [data]);

  return (
    <div className="atcb" style={{ display: 'none' }}>
      {JSON.stringify(data)}
    </div>
  );
};

export default component((node, ctx) => {
  const element = <AddToCalendar ctx={ctx} node={node} />;
  ReactDOM.render(element, node);

  // Unmount component on Pjax navigation
  return function () {
    try {
      ReactDOM.unmountComponentAtNode(node);
    } catch (e) {
      console.error(e);
    }
  };
});
